import { Badge } from '../kit'
import { Bien } from '../../types/inventario'
import { ESTADO, ESTADO_FISICO, TIPO } from '../../utils/inventario'

/** Tipo, estado físico, lo que está pendiente y si va a teletrabajo (la ficha del QR no trae esos dos). */
export function BadgesBien({ bien, conTipo = true }: {
  bien: Pick<Bien, 'tipo' | 'estado' | 'estado_fisico'> & { etiqueta_pendiente?: boolean; teletrabajo?: boolean }
  conTipo?: boolean
}) {
  return (
    <span className="badges">
      {conTipo && <Badge tono={TIPO[bien.tipo].tono}>{TIPO[bien.tipo].corto}</Badge>}
      {bien.estado_fisico && <Badge tono={ESTADO_FISICO[bien.estado_fisico].tono}>{ESTADO_FISICO[bien.estado_fisico].texto}</Badge>}
      {bien.estado !== 'ACTIVO' && <Badge tono={ESTADO[bien.estado].tono}>{ESTADO[bien.estado].texto}</Badge>}
      {bien.etiqueta_pendiente && <Badge tono="aviso">Etiqueta pendiente</Badge>}
      {bien.teletrabajo && <Badge tono="info">Teletrabajo</Badge>}
    </span>
  )
}
